import {
  Box,
  Container,
  Heading,
  VStack,
  Text,
  HStack,
  CircularProgress,
  Breadcrumb,
  BreadcrumbItem,
  FormControl,
  List,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";
import { useParams } from "react-router-dom";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Button from "components/Button/Button";
import Select from "components/Select/Select";

import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import { useMemo, useState } from "react";

// import toLower from "lodash/toLower";
// import formatter from "util/formatter";

import { useGetUserCardTransactionsQuery } from "services/cardsApi";
// import { formatDistance, parseISO } from "date-fns";

import { CgDatabase } from "react-icons/cg";
import { TransactionItem } from "./MyCardTransactions";

const AllMyCardTransactions = (props) => {
  const currentPage = "Card";

  const { id } = useParams();

  const [state, setState] = useState({});
  const [queries, setQueries] = useState(`cardId=${id}`);

  const { data, isLoading, isFetching } =
    useGetUserCardTransactionsQuery(queries);

  // const totalTx = useMemo(() => data?.data?.totalCount, [data]);
  const transactions = useMemo(() => data?.data?.transactions, [data]);

  console.log("TRANSACTIONS", transactions);

  const handleFilters = (filter) => {
    // const params = {
    //   cardId: id,
    //   // limit: 10,
    //   // page: 1,
    // };
    setState({ ...state, ...filter });
    const params = new URLSearchParams(queries);
    if (filter?.cardType === "all" && params.has("type")) params.delete("type");
    if (filter?.cardType !== "all") params.set("type", filter?.cardType);

    console.log("FILTER", params.toString());
    setQueries(params.toString());
  };

  // const getColor = (type) => {
  //   const map = {
  //     credit: "#00BA88",
  //     debit: "#ED2E7E",
  //   };

  //   return map[type ?? "credit"];
  // };

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["24px", "0", "0"]}>
              <HStack>
                <Heading>Cards</Heading>
                {/* {isFetching && (
                <CircularProgress
                  ml="20px !important"
                  isIndeterminate
                  color="var(--primary)"
                  size="20px"
                />
              )} */}
              </HStack>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/cards">Cards</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/cards/${id}`}>
                    My Card
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Transactions
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <FormControl maxW="180px" mt="32px">
              <Select
                disabled={isLoading || isFetching}
                label="Filter card type"
                value={state?.cardType ?? ""}
                onChange={(e) => handleFilters({ cardType: e.target.value })}
              >
                <option value="all">All</option>
                <option value="credit">Credit</option>
                <option value="debit">Debit</option>
              </Select>
            </FormControl>

            <Box
              bg="white"
              border="1px solid #8688942f"
              // minH="681px"
              maxW="calc(100% - 25vw)"
              // w="fit-content"
              mt="22px"
              borderRadius="8px"
              p="28px"
            >
              <HStack>
                <Heading fontSize="md" py="12px">
                  All Transactions
                </Heading>

                {isFetching && (
                  <CircularProgress
                    ml="20px !important"
                    isIndeterminate
                    color="var(--primary)"
                    size="18px"
                  />
                )}
              </HStack>

              {isLoading && (
                <HStack alignItems="center" justifyContent="center" py="20px">
                  <CircularProgress
                    ml="20px !important"
                    isIndeterminate
                    color="var(--primary)"
                    size="20px"
                  />
                </HStack>
              )}

              {transactions?.length < 1 && !isLoading && !isFetching && (
                <VStack py="32px">
                  <Box as={CgDatabase} fontSize="48px" color="grey" />
                  <Text color="grey">No Data</Text>
                </VStack>
              )}

              {transactions && !isLoading && (
                <List mt="12px">
                  {transactions.map((tx, i) => (
                    <TransactionItem key={`transaction-item-${i}`} {...tx} />
                    // <ListItem
                    //   p="20px 0"
                    //   borderBottom={
                    //     //   i !== items.length - 1 ? "1px solid #D9DBE9" : "none"
                    //     "1px solid #D9DBE9"
                    //   }
                    // >
                    //   <HStack justifyContent="space-between">
                    //     <HStack alignItems="flex-start">
                    //       <Box
                    //         mt="6px !important"
                    //         borderRadius="50%"
                    //         boxSize="10px"
                    //         bg={getColor(tx.type)}
                    //       />
                    //       <Box>
                    //         <Text
                    //           fontSize="sm"
                    //           fontWeight="500"
                    //           color="#595B67"
                    //         >
                    //           {tx.description}
                    //         </Text>
                    //         <Text fontSize="10px">
                    //           {/* {format(
                    //             parseISO(tx.createdAt),
                    //             "eee, dd MMM yyyy, HH:mm"
                    //           )} */}
                    //           {formatDistance(
                    //             parseISO(tx.createdAt),
                    //             new Date()
                    //           )}{" "}
                    //           ago
                    //         </Text>
                    //       </Box>
                    //     </HStack>

                    //     <Text>
                    //       {tx.type === "debit" ? "-" : ""}
                    //       {formatter(tx.currency).format(
                    //         tx.value?.$numberDecimal
                    //       )}
                    //     </Text>
                    //   </HStack>
                    // </ListItem>
                  ))}
                </List>
              )}
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default AllMyCardTransactions;
